export default __webpack_public_path__ + "static/media/1904.9584e3fb.png";